import { Layout, Result404 } from 'components';
import { ResultError } from 'components/errors';
import { AccountSettingsView } from 'features/account-settings';
import { LoginView } from 'features/auth';
import DashboardView from 'features/dashboard/routes/dashboard-view';
import LayoutView from 'features/dashboard/routes/layoutView';
import { LoadingLog } from 'features/loading-log/routes/loading';
import { LogDetails } from 'features/log/routes/LogDetails';
import { LogView } from 'features/log/routes/LogView';
import { LogVechileLoadingView } from 'features/log/routes/VechileLogLoading';
import { LogVechileUpLoadingView } from 'features/log/routes/VechileLogupLoading';
import { MatrialView } from 'features/master/routes/matrial-view';
import { StationMasterView } from 'features/master/routes/station-view';
import { SupplierView } from 'features/master/routes/supplier-view';
import { WeighBridge } from 'features/master/routes/weighbride';
import { MaterialView } from 'features/material-details/routes/material-details-view';
import NotificationView from 'features/Notifications/routes/notification-view';
import { PurchaseItemView } from 'features/report/routes/PurchaseView';
import { SalesItemView } from 'features/report/routes/SalesView';
import { TatView } from 'features/report/routes/TatView';
import { TolranceItemView } from 'features/report/routes/TolranceView';
import { VechileReportItemView } from 'features/report/routes/VechileReport';
//import { ReportView } from 'features/report/routes/report-view';
import { UnloadingLog } from 'features/unloading-log/routes/unloading';
import { AdminDetailView, EndUsersView } from 'features/users';
import { RoleManagementView } from 'features/users/routes';
import { EndUserUpdateView } from 'features/users/routes/end-user-update';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';

import { AuthenticatedRoute } from './authenticated-route';
import { ROUTES, SideBarMenus } from './constants';
import { RestrictedRoute } from './restricted-route';
import { UnauthenticatedRoute } from './unauthenticated-route';



export const routerConfig: RouteObject[] = [
  {
    errorElement: <ResultError />,
    children: [
      {
        path: ROUTES.LOGIN,
        element: (
          <UnauthenticatedRoute>
            <LoginView />
          </UnauthenticatedRoute>
        ),
      },

      {
        path: ROUTES.HOME,
        element: (
          <AuthenticatedRoute>
            <Layout />
          </AuthenticatedRoute>
        ),
        children: [
          {
            path: ROUTES.HOME,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.DASHBOARD}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <Navigate to={ROUTES.DASHBOARD} replace />
              </RestrictedRoute>
            )
            ,
            // element: <Navigate to={ROUTES.DASHBOARD} replace />,
          },
          {
            path: ROUTES.ACCOUNT_SETTINGS,
            element: <AccountSettingsView />,
          },

          {
            path: ROUTES.USERS_APP,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.ADMIN}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <EndUsersView />
              </RestrictedRoute>
            ),
            children: [
              {
                path: ROUTES.USERS_APP_EDIT,
                element: (
                  <RestrictedRoute
                    pageKey={SideBarMenus.ADMIN}
                    required={'view'}
                    redirectPath={ROUTES.LAYOUTVIEW}
                  >
                    <EndUserUpdateView />
                  </RestrictedRoute>
                ),
              },
            ],
          },
          {
            path: ROUTES.USERS_ADMIN_DETAIL,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.ADMIN}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <AdminDetailView />
              </RestrictedRoute>
            )
          },
          {
            path: ROUTES.DASHBOARD,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.DASHBOARD}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <DashboardView />
              </RestrictedRoute>
            ),
          },
          // {
          //   path: ROUTES.REPORT,
          //   element: (
          //     <RestrictedRoute
          //       pageKey={SideBarMenus.REPORTS}
          //       required={'view'}
          //       redirectPath={ROUTES.LAYOUTVIEW}
          //     >
          //       <ReportView />
          //     </RestrictedRoute>
          //   ),
          // },
          {
            path: ROUTES.TAT,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.TATREPORT}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <TatView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.TOLRANCE,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.TOLERANCEREPORT}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <TolranceItemView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.VECHILE,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.VEHICLEREPORT}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <VechileReportItemView />
              </RestrictedRoute>
            ),
          },
             {
            path: ROUTES.SALES,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.SALES}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <SalesItemView />
              </RestrictedRoute>
            ),
          },
           {
            path: ROUTES.PURACHASE,
            element: (
              // <RestrictedRoute
              //   pageKey={}
              //   required={'view'}
              //   redirectPath={ROUTES.LAYOUTVIEW}
              // >
                <PurchaseItemView />
              // </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.MATERIAL,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.MATERIAL}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <MatrialView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.SUPPLIER,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.SUPPLIER}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <SupplierView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.STATION,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.STATIONS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <StationMasterView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.WEIGHBRIDEGE,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.WBPRIORITY}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <WeighBridge />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LOG,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.ENTRYLOGS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <LogView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LOADING_LOG,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.LOADINGLOGS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <LoadingLog />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.UNLOADING_LOG,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.UNLOADINGLOGS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <UnloadingLog />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.MATERIAL_DETAIL_LOG,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.MATERIAL}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <MaterialView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LOG_ADMIN_DETAIL,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.ENTRYLOGS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <LogDetails />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LOG_LOADING,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.LOADINGLOGS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <LogVechileLoadingView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LOG_UPLOADING,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.UNLOADINGLOGS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <LogVechileUpLoadingView />
              </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.RoleManagement,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.USERMANAGEMENT}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <RoleManagementView />
              </RestrictedRoute>
            ),
            children: [],
          },
          {
            path: ROUTES.NOTIFICATION,
            element: (
              <RestrictedRoute
                pageKey={SideBarMenus.NOTIFICATIONS}
                required={'view'}
                redirectPath={ROUTES.LAYOUTVIEW}
              >
                <NotificationView />
               </RestrictedRoute>
            ),
          },
          {
            path: ROUTES.LAYOUTVIEW,
            element: (

              <LayoutView />

            ),
          }
        ],
      },
 
      {
        path: ROUTES.NOT_FOUND,
        element: <Result404 />,
      },
    ],
  },
];

export const router = createBrowserRouter(routerConfig);
